var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emojis"},_vm._l((_vm.$global.dictionary.emojis),function(emoji,name,idx){return _c('a',{key:idx,staticClass:"emoji",on:{"click":function($event){return _vm.addEmoji(emoji)}}},[_c('span',[_vm._v(_vm._s(emoji))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }